import "./sellscreendialogs.scss";
import * as React from "react";
import { connect, type ConnectedProps } from "react-redux";
import { type ThunkDispatch } from "redux-thunk";
import { hideDialog } from "../../../Actions/Dialogs/DialogActions";
import { searchInvoices } from "../../../Actions/SellScreen/SellScreenActions";
import Button from "../../../Common/Buttons/Button";

const connector = connect();

interface Props extends ConnectedProps<typeof connector> {
    dispatch: ThunkDispatch<any, any, any>;
}

interface State {
    value: string;
}

class ReloadInvoice extends React.Component<Props, State> {
    protected inputRef: React.RefObject<HTMLInputElement | null>;

    constructor(props: Props) {
        super(props);

        this.state = {
            value: "",
        };

        this.inputRef = React.createRef();

        this.findInvoice = this.findInvoice.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.cancelRequest = this.cancelRequest.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
    }

    public componentDidMount(): void {
        if(this.inputRef.current) {
            this.inputRef.current.focus();
        }
    }

    protected findInvoice(): false {
        this.props.dispatch(hideDialog());
        this.props.dispatch(searchInvoices(this.state.value));

        // STOP DIALOG BOX FROM CLOSING OVERLAY
        return false;
    }

    protected handleKeyDown(e: React.KeyboardEvent): void {
        if(e.key === "Enter") {
            this.findInvoice();
        }
    }

    protected handleChange(e: React.ChangeEvent<HTMLInputElement>): void {
        const value = e.currentTarget.value;

        this.setState({
            value: value,
        });
    }

    protected cancelRequest(): void {
        this.props.dispatch(hideDialog());
    }

    public render(): React.ReactNode {
        return (
            <div className="request-reload-invoice">
                <p>Please enter invoice number</p>
                <input
                    type="text"
                    name="invoiceNo"
                    value={this.state.value}
                    onChange={this.handleChange}
                    onKeyDown={this.handleKeyDown}
                    ref={this.inputRef}
                />
                <div className="buttons">
                    <Button type="button" classes={[ "button-cancel" ]} onClick={this.cancelRequest}>Cancel</Button>
                    <Button type="button" classes={[ "button-save" ]} onClick={this.findInvoice}>Reload</Button>
                </div>
            </div>
        );
    }
}

export default connector(ReloadInvoice);
